import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListeAbschliessenStepperHandler, ListeAbschliessenStepperOpenOptions } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-abgang/liste-abschliessen-stepper.handler';
import { Tierliste } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/tierliste';
import { DashboardEinstallenStepperDialogComponent } from './dashboard-einstallen-stepper-dialog/dashboard-einstallen-stepper-dialog.component';
import { DashboardEinstallenStepperDialogData } from './dashboard-einstallen-stepper-dialog/dashboard-einstallen-stepper-dialog.data';

@Injectable()
export class DashboardListeAbschliessenStepperHandler implements ListeAbschliessenStepperHandler {
    constructor(private readonly dialog: MatDialog) {}

    open(tierliste: Tierliste, options?: ListeAbschliessenStepperOpenOptions): Observable<boolean> {
        const tierlisteId = Number(tierliste?.tierliste_id || 0);
        if (tierlisteId <= 0) {
            return new Observable<boolean>(subscriber => {
                subscriber.next(false);
                subscriber.complete();
            });
        }

        const transferHint = tierliste.transfer_innerhalb_betrieb;
        const initialStep = options?.initialStep === 'ausstallen' ? 'ausstallen' : 'tiere';
        const data: DashboardEinstallenStepperDialogData = {
            continueAbgangTierliste: {
                tierlisteId,
                kundeId: Number(tierliste.kunde_id_abgang) || null,
                transferInnerhalbBetrieb:
                    Number(transferHint) === 1 ? true : Number(transferHint) === 0 ? false : undefined,
                initialStep,
            },
        };

        return this.dialog
            .open(DashboardEinstallenStepperDialogComponent, {
                width: '1100px',
                maxWidth: '96vw',
                maxHeight: '92vh',
                panelClass: 'dashboard-einstallen-stepper-dialog-panel',
                autoFocus: false,
                restoreFocus: false,
                data,
            })
            .afterClosed()
            .pipe(map(result => !!result));
    }
}
